import { render, staticRenderFns } from "./Forma_farmaceutica.vue?vue&type=template&id=409739ee"
import script from "./Forma_farmaceutica.vue?vue&type=script&lang=js"
export * from "./Forma_farmaceutica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports